import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';

@Component({
  selector: 'page-sales-report',
  templateUrl: 'sales-report.html',
})
export class SalesReportPage {
	daily_reports: any = [];
	monthly_reports: any = [];
	yearly_reports: any = [];
	year_filter: any;
	month_filter: any;
	date_filter: any;
  report_type: any = 'daily';
  show_counters = false;
  total_orders = 0;
  total_amount = 0;
  year_list: any  = [];
  month_list: any  = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  daily_summary: any = {};
  monthly_summary: any = {};
  yearly_summary: any = {};
  constructor(public navCtrl: NavController, public navParams: NavParams, public DBservice: DbservicesProvider) {
  	let today_date = new Date();
  	this.date_filter = today_date.toISOString().split('T')[0];
  	this.month_filter = today_date.toLocaleString('default', { month: 'long' });
  	this.year_filter = today_date.getFullYear();
    this.get_years_list();
    this.year_list = [this.year_filter];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SalesReportPage');
  }

  ionViewWillEnter() {
  	this.daily_report();
  	this.monthly_report();
  	this.yearly_report();
  }

  get_years_list() {
    this.DBservice.get_years_list()
    .then(r => {
      if(r.message){
        this.year_list = r.message.split('\n');
        console.log(this.year_list)
      }
    }, error => {
      console.log(JSON.stringify(error.json()));
    })
  }

  daily_report() {
  	let data = {
  		date: this.date_filter,
  		business: localStorage.restaurant
  	}
  	this.DBservice.daily_sales_report(data)
  	.then(r=>{
      this.daily_reports = r.message.data;
      this.daily_summary = r.message.summary;
      this.daily_summary.actual_orders = this.daily_summary.total_orders - this.daily_summary.cancelled_orders;
      
  	}, error =>{
  		console.log(JSON.parse(error.json()));
  	})
  }

  monthly_report() {
  	let data = {
  		month: this.month_filter,
  		year: this.year_filter,
  		business: localStorage.restaurant
  	}
  	this.DBservice.monthly_sales_report(data)
  	.then(r=>{
      this.monthly_reports = r.message.data;
      this.monthly_summary = r.message.summary;
      this.monthly_summary.actual_orders = this.monthly_summary.total_orders - this.monthly_summary.cancelled_orders;
  	}, error =>{
  		console.log(JSON.parse(error.json()));
  	})
  }

  yearly_report() {
  	let data = {
  		year: this.year_filter,
  		business: localStorage.restaurant
  	}
  	this.DBservice.yearly_sales_report(data)
  	.then(r=>{
      this.yearly_reports = r.message.data;
      this.yearly_summary = r.message.summary;
  	}, error =>{
  		console.log(JSON.parse(error.json()));
  	})
  }

  report_view_changed(evt){
    this.show_counters = false;
    this.report_type = evt._value;
  }

  year_filter_changed(val){
    this.year_filter = val;
    // this.yearly_report();
    if(this.report_type == 'yearly')
      this.yearly_report();
    else if(this.report_type == 'monthly')
      this.monthly_report();
  }

  month_filter_changed(val){
    this.month_filter = val;
    this.monthly_report();
  }

  date_filter_changed(){
    this.daily_report();
  }

  move_tab(tab, sale){
    // this.show_counters = true;
    // this
    if(tab == 'month'){
      this.month_filter = sale.month;
      this.report_type = 'monthly';
      this.total_orders = sale.total_orders;
      this.total_amount = sale.total_amt;
      this.monthly_report();
    } else if(tab == 'date'){
      this.date_filter = sale.order_date;
      this.report_type = 'daily';
      this.total_orders = sale.total_orders;
      this.total_amount = sale.total_amount;
      this.daily_report();
    }
    this.show_counters = true;
  }

  prev_date() {
    let selected_date = new Date(this.date_filter);
    selected_date.setDate(selected_date.getDate() - 1);
    this.date_filter = selected_date.toISOString().split('T')[0];
    this.daily_report();
  }

  next_date() {
    let selected_date = new Date(this.date_filter);
    selected_date.setDate(selected_date.getDate() + 1);
    if(selected_date > new Date())
      return;
    this.date_filter = selected_date.toISOString().split('T')[0];
    this.daily_report();
  }

  prev_month() {
    let month_index = this.month_list.indexOf(this.month_filter);
    if(month_index == 0){
      if(this.year_list.indexOf(this.year_filter) > 0){
        this.month_filter = this.month_filter[11];
        this.year_filter = this.year_list[this.year_list.indexOf(this.year_filter) - 1];
      } else{
        return;
      }
    } else{
      this.month_filter = this.month_list[month_index - 1];
    }
    this.monthly_report();
  }

  next_month() {
    let month_index = this.month_list.indexOf(this.month_filter);
    if(month_index == 11){
      if(this.year_list.length > (this.year_list.indexOf(this.year_filter) + 1)){
        this.month_filter = this.month_list[0];
        this.year_filter = this.year_list[this.year_list.indexOf(this.year_filter) + 1];
      } else{
        return;
      }
    } else{
      this.month_filter = this.month_list[month_index + 1];
    }
    this.monthly_report();
  }

  send_via_mail() {
    var data: any = {};
    data.user = localStorage.adminRefId;
    data.report_type = 'HTML';
    if(this.report_type == 'daily'){
      data.filters = JSON.stringify({
        'date': this.date_filter,
        'business': localStorage.restaurant
      });
      data.report_name = 'Daily Sales Report';
    } else if(this.report_type == 'monthly'){
      data.filters = JSON.stringify({
        'year': this.year_filter,
        'month': this.month_filter,
        'business': localStorage.restaurant
      });
      data.report_name = 'Monthly Sales Report';
    } else if(this.report_type == 'yearly'){
      data.filters = JSON.stringify({
        'year': this.year_filter,
        'business': localStorage.restaurant
      });
      data.report_name = 'Yearly Sales Report';
    }
    this.DBservice.send_report_via_mail(data)
    .then(r => {
      console.log(r)
    }, error => {
      console.log(JSON.stringify(error.json()))
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/sales-report/sales-report.ts